import HeaderModule from "./modules/headerObserver.module";
import NavigationModule from "./modules/navigation.module";
import AnchorObserverModule from "./modules/anchorObserver.module";
// import TextCarouselModule from "core/textCarousel.core";


class App {

	private headerModule = new HeaderModule()
	private navigationModule = new NavigationModule()
	private anchorModule = new AnchorObserverModule()
	// private textCarouselModule = new TextCarouselModule();

	constructor() {
		/* ── Header ─────────────────────────────── */
		this.headerModule.addWatcherToHeaderOnScroll()
		this.headerModule.setHeaderShadow()
		// this.headerModule.setMainElementToMatchHeader()
		// this.headerModule.addBoxShadowWhenNotPrimaryBg()


		/* ── Navigation ─────────────────────────── */
		this.navigationModule.disableAttributes()
		this.navigationModule.handleActiveLinkOnPageLoad()
		this.navigationModule.handleNavBarDropdown()
		// this.navigationModule.handleNavBarToggleButton()

		/* ── Anchor Observer ────────────────────── */
		this.anchorModule.toggleAnimation();

		/* ── Text Carousel ──────────────────────── */
		// this.textCarouselModule.init();

		/* Dev helper – not related to navigation */
		localStorage.clear();
	}
}

export const myApp = new App();
